import { h, defineComponent } from 'vue';
import LogoutButton from '@/ui/components/button/LogoutButton.vue';
import { logo } from '@/ui/components';
import { useCurrentRoute } from '@/ui/routes';

interface LogoLayoutProps {
  showLogout?: boolean;
}

export default defineComponent<LogoLayoutProps>({
  name: 'LogoLayout',
  props: ['showLogout'],
  setup(props) {
    return function render() {
      const currentRoute = useCurrentRoute();

      return h('div', {
        class: `logo-layout ${currentRoute.value.meta!.classes ?? ''}`,
      }, [
        h('div', { class: 'logo-layout__logo-container' }, [
          logo({ customClass: 'logo-img--logo-layout' }),
          props.showLogout && h(LogoutButton, { attrs: { class: 'logo-layout__btn-logout' } }),
        ]),
        h('div', { class: 'logo-layout__content container' }, [
          h('router-view'),
        ]),
      ]);
    };
  },
});
